module.exports = __webpack_public_path__ + "img/icon-invoice.580df939.png";